import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { SessionStore } from '../state/session.store';

export const jwtCaptureInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionStore);

  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse && event.headers.has('Authorization')) {
        const token = event.headers.get('Authorization')?.split('Bearer ').pop();
        if (token) {
          session.setAccessToken(token);
        }
      }
    }),
  );
};
